var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Neue Veranstaltung"}},[_c('event-form',{attrs:{"event":_vm.event,"submit-label":"Neue Veranstaltung anlegen","form-submitted":_vm.saveEvent,"mode":"new"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }